export function getUserEmail() {
	return localStorage.getItem('user-email');
}
